export default {
  'adsUserPushRecord.title': 'Lịch sử đẩy thông báo',
  'adsUserPushRecord.memberId': 'ID thành viên',
  'adsUserPushRecord.memberAccount': 'Tài khoản thành viên',
  'adsUserPushRecord.adsName': 'Tên cấu hình quy kết',
  'adsUserPushRecord.agentAccount': 'Tài khoản đại lý',
  'adsUserPushRecord.adsType': 'Kênh quy kết',
  'adsUserPushRecord.status': 'Trạng thái',
  'adsUserPushRecord.eventName': 'Tên sự kiện',
  'adsUserPushRecord.dateRange': 'Phạm vi ngày',
  'adsUserPushRecord.search': 'Tìm kiếm',
  'adsUserPushRecord.reset': 'Đặt lại',
  'adsUserPushRecord.userId': 'ID người dùng',
  'adsUserPushRecord.userName': 'Tên người dùng',
  'adsUserPushRecord.agentName': 'Tên đại lý',
  'adsUserPushRecord.pushTime': 'Thời gian đẩy',
  'adsUserPushRecord.action': 'Hành động',
  'adsUserPushRecord.viewParams': 'Xem tham số',
  'adsUserPushRecord.retry': 'Thử lại',
  'adsUserPushRecord.batchRetryFailed': 'Thử lại hàng loạt bản ghi thất bại ({count} mục)',
  'adsUserPushRecord.paramDetail': 'Chi tiết tham số',
  'adsUserPushRecord.paramDisclaimer': '*Các tham số trên trang này chỉ để tham khảo, tuân theo tài liệu tích hợp của nhà cung cấp quy kết*',
  'adsUserPushRecord.batchRetryTitle': 'Thử lại hàng loạt',
  'adsUserPushRecord.batchRetryConfirm': 'Các bản ghi thất bại sau sẽ được thử lại trong lô này:',
  'adsUserPushRecord.batchRetryItem': '• Tài khoản thành viên: {account}, Sự kiện: {event}, Thời gian đẩy: {time}',
  'adsUserPushRecord.batchRetryWarning': 'Vui lòng xác nhận thử lại hàng loạt, thao tác này không thể hoàn tác.',
  'adsUserPushRecord.confirm': 'Xác nhận',
  'adsUserPushRecord.cancel': 'Hủy',
  'adsUserPushRecord.retrySuccess': 'Thử lại thành công',
  'adsUserPushRecord.retryFailed': 'Thử lại thất bại',
  'adsUserPushRecord.batchRetrySuccess': 'Thử lại hàng loạt thành công',
  "adsUserPushRecord.loadingFailedRecords": "Đang lấy các bản ghi thất bại...",
  "adsUserPushRecord.noFailedRecordsToRetry": "Hiện tại không có bản ghi thất bại nào để thử lại",
  'adsUserPushRecord.fetchDataFailed': 'Không thể tải dữ liệu',
  'adsUserPushRecord.fetchAgentsFailed': 'Không thể tải danh sách đại lý',
  'adsUserPushRecord.fetchFailedRecordsFailed': 'Không thể tải bản ghi thất bại',
  'adsUserPushRecord.pagination': 'Trang {current} của {page}, Tổng {total} bản ghi',
  'adsUserPushRecord.noData': 'Không có dữ liệu',
};
